module.exports = __webpack_public_path__ + "static/img/bg.407b083f.png";